// src/components/FourSquaresIcon.js
import React from 'react';

const FourSquaresIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    {/* Top-left square */}
    <rect x="4" y="4" width="6" height="6" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
    {/* Top-right square */}
    <rect x="14" y="4" width="6" height="6" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
    {/* Bottom-left square */}
    <rect x="4" y="14" width="6" height="6" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
    {/* Bottom-right square */}
    <rect x="14" y="14" width="6" height="6" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
);

export default FourSquaresIcon;
